import { useContext } from 'react';
import { BreakpointContext, XLARGE } from '@core-ui/breakpoint-provider';

export const useMobile = ():boolean => {
  const { smallerThan } = useContext(BreakpointContext);

  return smallerThan(XLARGE);
};
